import { render, staticRenderFns } from "./orderCreateApprove.vue?vue&type=template&id=b80f5340&scoped=true"
import script from "./orderCreateApprove.vue?vue&type=script&lang=js"
export * from "./orderCreateApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCreateApprove.vue?vue&type=style&index=0&id=b80f5340&prod&lang=css"
import style1 from "./orderCreateApprove.vue?vue&type=style&index=1&id=b80f5340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f5340",
  null
  
)

export default component.exports